import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BoardHeroDemoFormPanelComponent } from "./board-hero-demo-form-panel.component";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { RecaptchaModule } from "ng-recaptcha";

@NgModule({
  declarations: [BoardHeroDemoFormPanelComponent],
  exports: [BoardHeroDemoFormPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    RecaptchaModule,
  ],
})
export class BoardHeroDemoFormPanelModule {}
